const EditIconForEditFLow = ({
  height = "40px",
  width = "40px",
}: {
  height?: string;
  width?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_930_4649)">
        <path
          d="M32.5 40H7.5C3.35754 40 0 36.6425 0 32.5V7.5C0 3.35754 3.35754 0 7.5 0H32.5C36.6425 0 40 3.35754 40 7.5V32.5C40 36.6425 36.6425 40 32.5 40Z"
          fill="#E9EEFE"
        />
        <path
          d="M21.6913 14.2129L11.1051 24.7979C11.0514 24.8516 11.0138 24.9178 10.9949 24.9917L9.82119 29.7003C9.7864 29.8428 9.8276 29.9929 9.93136 30.0955C10.0101 30.1742 10.1163 30.2178 10.2262 30.2178C10.26 30.2178 10.2939 30.2142 10.3275 30.2053L15.0363 29.0316C15.1099 29.0127 15.1764 28.9755 15.2301 28.9214L25.8152 18.3364L21.6913 14.2129Z"
          fill="#183883"
        />
        <path
          d="M28.4375 12.769L27.2586 11.5901C26.4713 10.8027 25.0989 10.8039 24.3124 11.5901L22.8687 13.0338L26.9937 17.1589L28.4375 15.7151C28.8312 15.3214 29.0475 14.799 29.0475 14.2414C29.0475 13.6851 28.8312 13.1626 28.4375 12.769Z"
          fill="#718AD6"
        />
      </g>
      <defs>
        <clipPath id="clip0_930_4649">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default EditIconForEditFLow;
